import { render, staticRenderFns } from "./HorizontalLineText.vue?vue&type=template&id=a0679fce"
var script = {}
import style0 from "./HorizontalLineText.vue?vue&type=style&index=0&id=a0679fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports